import { ColumnFiltersState } from "@tanstack/react-table";
import { DocumentsQuery } from "api";

export const getColumnFilterPayload = (
    columnFilters: ColumnFiltersState,
    searchQuery: DocumentsQuery
): DocumentsQuery => {

    if (!columnFilters || columnFilters?.length === 0) return searchQuery;

    const res: DocumentsQuery = {};

    const convertStringToNumberIfNumeric = (input: any): undefined | number => {
        const parsed = parseFloat(input);
        if (!Number.isNaN(parsed) && parsed.toString() === input.trim()) {
            return parsed;
        }
        return undefined;
    }

    columnFilters.forEach(({ id, value }) => {
        switch (id) {
            case 'fileName':
                res.fileName = typeof value === 'string' ? value : undefined;
                break;
            case 'site':
                res.siteName = typeof value === 'string' ? value : undefined;
                break;
            case 'utilityType':
                res.utilityName = typeof value === 'string' ? value : undefined;
                break;
            case 'uploader':
                res.uploader = typeof value === 'string' ? value : undefined;
                break;
            case 'uploadDate':
                res.uploadedAt = typeof value === 'string' ? value : undefined;
                break;
            case 'pages':
                res.pages = convertStringToNumberIfNumeric(value);
                break;
            case 'Data entries':
                res.dataEntries = convertStringToNumberIfNumeric(value);
                break;
            case 'bills':
                res.dataEntriesStatus = typeof value === 'string' ? value : undefined;
                break;
            case 'aiExtraction':
                res.aiExtraction = typeof value === 'string' ? (value.trim().toLowerCase() === 'na' ? 'NA' : value.trim().replace('%', '')) : undefined;
                break;
            case 'aiAlgorithm':
                res.aiAlgorithm = typeof value === 'string' ? value : undefined;
                break;
            default:
                break;
        }
    });

    return {
        ...searchQuery,
        ...res,
    };
};
